// Échelle canonique partagée avec PATache::PRIORITES côté API.
// 0 = aucune, 1 = basse, 2 = normale, 3 = haute, 4 = critique.
export const PLANNING_PRIORITIES = [
    { value: 4, key: 'critique', label: 'Critique', color: '#F82121', bg: 'rgba(248,33,33,0.10)' },
    { value: 3, key: 'haute', label: 'Haute', color: '#FF9436', bg: 'rgba(255,148,54,0.10)' },
    { value: 2, key: 'normale', label: 'Normale', color: '#00B0FF', bg: 'rgba(0,176,255,0.10)' },
    { value: 1, key: 'basse', label: 'Basse', color: '#66BE63', bg: 'rgba(102,190,99,0.10)' },
    { value: 0, key: 'aucune', label: 'Aucune', color: '#A8B0B3', bg: 'rgba(168,176,179,0.10)' },
];

export const getPlanningPriority = (value) => {
    const parsed = Number(value);
    return PLANNING_PRIORITIES.find(priority => priority.value === parsed)
        || PLANNING_PRIORITIES.find(priority => priority.value === 2);
};

export const toPlanningPriorityValue = (value) => Number(value);
